<template>
    <div class="mine">
       <div class="user-top">
         <div class="header">
           <div class="avatar">
            <img v-if="userInfo" :src="userInfo.user.headimgurl" class="uimg"/>
           </div>
           <div class="uname">
             <div class="no-login">
              <span class="btn-login" v-if="userInfo">{{userInfo.user.nickname}}</span>
             </div>
           </div>
         </div>
       </div>
       <div class="quick-link">
         <div class="link-btns">
           <div class="btn-box">
              <div class="btn-icon qic-bg1" @click="navigateTo('/h5/profile/favorite')">
                <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-favo.png" class="icon-img" mode="aspectFit"/>
              </div>
              <div class="btn-text">我的收藏</div>
           </div>
         </div>
         <div class="link-btns">
           <div class="btn-box">
              <div class="btn-icon qic-bg2" @click="navigateTo('/h5/profile/reserve')">
                <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-reserve.png" class="icon-img" mode="aspectFit"/>
              </div>
              <div class="btn-text">我的约看</div>
           </div>
         </div>
         <div class="link-btns">
           <div class="btn-box">
              <div class="btn-icon qic-bg3" @click="navigateTo('/h5/profile/bought')">
                <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-buy.png" class="icon-img" mode="aspectFit"/>
              </div>
              <div class="btn-text">我买的车</div>
           </div>
         </div>
         <div class="link-btns">
           <div class="btn-box">
              <div class="btn-icon qic-bg4" @click="navigateTo('/h5/profile/sold')">
                <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-sell.png" class="icon-img" mode="aspectFit"/>
              </div>
              <div class="btn-text">我卖的车</div>
           </div>
         </div>
       </div>
       <div class="other-links">
          <div class="link-item" @click="navigateTo('/h5/profile/ticket?channelid=' + $route.query.id + '_2')">
            <div class="m-icon">
              <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-ticket.png" class="m-img" mode="aspectFit"/>
            </div>
            <div class="m-txt">我的优惠券</div>
            <div class="iconfont uc-jinru go-to"></div>
          </div>
          <a href="tel:0874-3418111">
            <div class="link-item">
              <div class="m-icon">
                <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-services.png" class="m-img" mode="aspectFit"/>
              </div>
              <div class="m-txt">联系客服</div>
              <div class="iconfont uc-jinru go-to"></div>
            </div>
          </a>
       </div>
     </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { getUsedCarList } from './api'
import { mapState } from "vuex";
import { MessageBox } from "mint-ui";
import Cookies from "js-cookie";
import { navigateTo } from './utils'

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data() {
    return {
      nickName: "",
      userName: "",
      avatar: "",
    };
  },
  filters: {

  },
  watch: {
    userInfo(newData){
      const { user : { headimgurl, nickname, name } } = newData
      this.nickName = nickname
      this.userName = name
      this.avatar = headimgurl
    }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
    ]),
  },
  methods: {
    navigateTo
  },
  created() {

  },
  mounted() {
    //console.log('this.userInfo:', this.userInfo)

  }
};
</script>
<style lang="scss" scoped>
.mine{
    width: 100%;
    .user-top{
        width: 100%;
        height: 3rem;
        background:#0D89FF;
        .header{
            display: flex;
            padding: 0.2rem 0.3rem;
            box-sizing: border-box;
            height: 1.7rem;
            .avatar{
                width: 1.7rem;
                .uimg{
                    width: 1.3rem;
                    height: 1.3rem;
                    border-radius: 50%;
                }
            }
            .uname{
                flex: 1;
                display: flex;
                .no-login{
                    height: 100%;
                    display:flex;
                    align-items: center;
                    .btn-login{
                        width: 1.6rem;
                        height: 0.6rem;
                        background: rgba(255,255,255,.3);
                        border-radius: 29px;
                        color: #FFFFFF;
                        line-height: 0.6rem;
                        font-size: 0.28rem;
                        text-align: center;
                    }
                }
            }
        }
    }
    .quick-link{
        margin: 0.3rem;
        height: 2.18rem;
        background: #FFFFFF;
        box-shadow: 0px 0.04rem 0.15rem 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        display: flex;
        position: relative;
        top: -1.3rem;
        .link-btns{
            flex: 1;
            .btn-box{
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 0.3rem;
            }
        }
        .btn-text{
            padding: 0.18rem 0rem .15rem 0rem;
            text-align: center;
            font-size: 0.24rem;
            color: #313131;
        }
        .btn-icon{
            width: 1.15rem;
            height: 1.15rem;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon-img{
                max-width: 0.55rem;
                max-height: 0.55rem;
            }
        }
        .qic-bg1{
            background: linear-gradient(0deg, #1FBC44, #49E885);
            box-shadow: 0px 0.06rem 0.1rem 0px rgba(106, 230, 86, 0.45);
        }
        .qic-bg2{
            background: linear-gradient(0deg, #386FED, #74A4F7);
            box-shadow: 0px 0.06rem 0.1rem 0px rgba(60, 115, 238, 0.45);
        }
        .qic-bg3{
            background: linear-gradient(0deg, #EC8239, #F1A056);
            box-shadow: 0px 0.06rem 0.1rem 0px rgba(237, 137, 63, 0.45);
        }
        .qic-bg4{
            background: linear-gradient(0deg, #F4BB47, #F5D864);
            box-shadow: 0px 0.06rem 0.1rem 0px rgba(244, 189, 73, 0.45);
        }
    }
    .other-links{
        margin: 0.3rem;
        padding: 0.1rem 0.2rem;
        display: flex;
        flex-direction: column;
        background-color: #FFFFFF;
        box-shadow: 0px 0.04rem 0.15rem 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        min-height: 5.5rem;
        position: relative;
        top: -1.2rem;
        .link-item{
            height: 0.8rem;
            display: flex;
            align-items: center;
            border-bottom: solid 1px #f1f1f1;
            position: relative;
            .m-icon{
                width: 0.6rem;
                display: flex;
                align-items: center;
                .m-img{
                    max-width: 0.4rem;
                    max-height: 0.4rem;
                }
            }
            .m-txt{
                color:#555;
                a{
                  color:#555;
                }
            }
            .go-to{
                position: absolute;
                right: 0.1px;
                top: 0.3rem;
                width: 0.15rem;
                height: 0.25rem;
                color:#666;
            }
            .btn-service{
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                bottom: 0px;
                opacity: 0;
            }
        }
    }
}
</style>